import { IconSend as TablerIconSend } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconSend = /*#__PURE__*/ createOutlineIcon(TablerIconSend, 'IconSend');
